<template>
    <p class="text-page-hero">
       <slot /> 
    </p>
</template>
<script>
export default {
    name:'Hero'
}
</script>